import React from "react";

import { SovosToolbarGroup, SovosBox, SovosToolbarActions } from "mosaic-react";
import { DefaultToolbar } from "colbi_web_ui/lib/components";
import DatagridExportButton from "../DatagridExportButton/DatagridExportButton";

const OrganizationProjectToolbar = ({ defaultToolbarProps, toolbarProps }) => {
    const { data, alternativeQueryData } = toolbarProps;
    return (
        <SovosToolbarGroup sx={{ width: "100%" }}>
            <SovosToolbarGroup
                sx={{ flex: "1 1 auto", justifyContent: "flex-start", paddingRight: "10px" }}
            >
                <SovosBox sx={{ display: "flex", flexDirection: "row" }}></SovosBox>
            </SovosToolbarGroup>
            <SovosToolbarGroup>
                <SovosToolbarActions>
                    <DatagridExportButton data={data} alternativeQueryData={alternativeQueryData} />
                    <DefaultToolbar {...defaultToolbarProps} />
                </SovosToolbarActions>
            </SovosToolbarGroup>
        </SovosToolbarGroup>
    );
};

export default OrganizationProjectToolbar;
